// extracted by mini-css-extract-plugin
module.exports = {"container":"_77e86908","value":"_8b9d71a4","closeIconWrapper":"_88448c41"};